import { render, staticRenderFns } from "./DkoCooperationAction.vue?vue&type=template&id=089c6428"
import script from "./DkoCooperationAction.vue?vue&type=script&lang=js"
export * from "./DkoCooperationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports